module.exports = __webpack_public_path__ + "b4ff349626acd7ce7059991c6d2fa417.png";